import { useEffect, useRef, useState } from "react";
import { IUsersDropdown } from "../../models/IDropdown";
import { Fetch } from "../../shared/Fetch";
import { JVDropdown } from "../../shared/JVDropdown";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";

interface Isct {
    salesManager?: number
}

interface Iprops {
    contactPerson?: number,
    salesManagerFrom?: number,
    contactPersonName?: string,
    open?: boolean,
    salesPerson_Company_ID?: number,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

const schema = yup.object({
    salesManager: yup.number().required("Select Sales Manager").min(1, "Select Sales Manager")
});

export const MutualClientTransfer = (props: Iprops) => {
    const [sales, setSales] = useState<Array<IUsersDropdown>>();
    const [loading, setLoading] = useState(false);

    const { control, handleSubmit, formState: { errors }, reset } = useForm<Isct>({
        resolver: yupResolver(schema),
        defaultValues: { salesManager: 0 },
        shouldFocusError: false
    });

    const loadSales = async () => {
        // console.log(props.salesPerson_Company_ID);
        const response = await Fetch("Dropdown/Userslist", "GET", null, `company_id=${props.salesPerson_Company_ID}&role_id=${2}`, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            setSales(data);
        }
    }

    useEffect(() => {
        if (props.open) {
            loadSales();
        }
    }, [props.open]);

    const salesClientTransfer = async (data: Isct, contactPerson?: number) => {
        setLoading(true);
        const contact: Array<{ ContactPersonID?: number }> = [];
        contact.push({ ContactPersonID: contactPerson });
        const response = await Fetch("Sub_Vendor_Contact_Person_Mast/mutualClients", "POST", null, `salesManagerFrom=${props.salesManagerFrom}&salesManagerTo=${data.salesManager}&contactPersons=${JSON.stringify(contact)}`, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', content: "Client Transfered Successfully." });
            setLoading(false);
            onHide();
            props.setReload(!props.reload);
        } else {
            setLoading(false);
        }
    }

    function onSubmit(data: Isct) {
        salesClientTransfer(data, props?.contactPerson);
    }

    function onHide() {
        props.hideDialog();
        reset();
    }

    return (
        <Dialog visible={props.open} style={{ width: '350px' }} header={`Transfer "${props.contactPersonName}" to`} className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVDropdown column={1} label="Sales Manager" control={control} name="salesManager" options={sales} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Sales Manager" error={errors.salesManager?.message} />
                <div className="field col-12 md:col-12">
                    <Button loading={loading} label="TRANSFER" type="submit"></Button>
                </div>
            </form>
        </Dialog>
    );
}